import {default as Error} from './Error';
import {default as Cancel} from './Cancel';
import {default as AnotherDeviceQr} from './AnotherDeviceQr';
import {default as StartApp} from './StartApp';
import {default as Collect} from './Collect';

export default {Error, Cancel, AnotherDeviceQr, StartApp, Collect};